import { render, staticRenderFns } from "./TableBranceUpgrade.vue?vue&type=template&id=5c2087f6&"
import script from "./TableBranceUpgrade.vue?vue&type=script&lang=js&"
export * from "./TableBranceUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports